import React, {useContext, useState} from "react";
import SnackbarContext from "../../providers/snackbar-context";
import {Box, Button, Text} from "@nike/eds";
import {InventoryOverviewTable} from "./InventoryOverviewTable";
import {edsSpace16} from "@nike/eds/dist/tokens";
import {InventoryOverviewSearchForm} from "./InventoryOverviewSearchForm";
import {InventoryOverviewSearchFormData} from "./model/InventoryOverviewSearchFormData";
import useNavigationAction from "../../common/hooks/useNavigationAction";

export function InventoryOverview({inventoryService, LocationTracker}) {

    const snackbarCtx = useContext(SnackbarContext);
    const [loading, setLoading] = useState(false);
    let [searchResults, setSearchResults] = useState([])
    let [pagingTokens, setPagingTokens] = useState([])

    const searchHandler = (inventoryOverviewSearchFormData: InventoryOverviewSearchFormData, restore : boolean) => {
        if (restore) {
            pagingTokens = pagingTokens.slice(0, -1);
        } else {
            pagingTokens = []
        }
        searchResults = [];
        fetchData(inventoryOverviewSearchFormData, 'down');
    }

    const calculateMaterial = (inventoryOverviewSearchFormData: InventoryOverviewSearchFormData) => {
        if (inventoryOverviewSearchFormData.materialNumbers && inventoryOverviewSearchFormData.materialNumbers.length > 0) {
            return inventoryOverviewSearchFormData.materialNumbers[0];
        }
        return "";
    }

    const fetchData = (inventoryOverviewSearchFormData: InventoryOverviewSearchFormData, direction: string) => {
        setLoading(true);

        if (direction === 'up') {
            // remove next and current tokens from the pagingTokens array to retrieve previous set
            pagingTokens.pop()
            pagingTokens.pop()
        }

        // at the moment materialNumbers only has one item in the array
        inventoryService.getAuditInventoryForMaterial(
            calculateMaterial(inventoryOverviewSearchFormData),
            inventoryOverviewSearchFormData.size,
            inventoryOverviewSearchFormData.countryOfOrigin,
            inventoryOverviewSearchFormData.quality,
            inventoryOverviewSearchFormData.imbalanceFilter,
            pagingTokens.at(-1)
        )
            .then(result => {
                setLoading(false);
                setSearchResults(result.data.inventoryDynamicSearch.items)
                setPagingTokens(pagingTokens.concat(result.data.inventoryDynamicSearch.nextToken))
            })
            .catch(error => {
                setLoading(false);
                snackbarCtx.displayMsg(error.message, "error");
            });
    };

    const titleStyle = {
        marginBottom: edsSpace16
    }

    const navigate = useNavigationAction();

    return (
        <div>
            <Text style={titleStyle} font={"display-3"} as={"h3"}>INVENTORY</Text>

            <Box className="eds-grid eds-grid--m-cols-4">
                <Box className="eds-grid--m-col-3 nesg-grid nesg-grid-md-cols-2 nesg-grid-items-center">
                    <InventoryOverviewTable inventoryService={inventoryService} searchResults={searchResults} loading={loading} />
                    <Button  onClick={() => navigate("downloadable-reports")}> Go to downloadable reports </Button>
                </Box>
                <InventoryOverviewSearchForm onSearch={searchHandler} />
                <LocationTracker location="Inventory Overview" sublocation="Overview" />
            </Box>
        </div>
    )

}